import { IScanSettings } from "./ScanSettings.props";

export type PartialScanSettings = Partial<IScanSettings>;

export const buildChangedScanSettingsPayload = (
    initialData: IScanSettings,
    currentData: IScanSettings,
    hasVtKeyEditIntent = false
): PartialScanSettings => {
    const payload: PartialScanSettings = {};

    if (initialData.no_result !== currentData.no_result) {
        payload.no_result = currentData.no_result;
    }

    if (initialData.on_error !== currentData.on_error) {
        payload.on_error = currentData.on_error;
    }

    if (initialData.vt_on !== currentData.vt_on) {
        payload.vt_on = currentData.vt_on;
    }

    if (initialData.vt_key !== currentData.vt_key || hasVtKeyEditIntent) {
        payload.vt_key = currentData.vt_key;
    }

    return payload;
};

export const mergeChangedSettings = (
    current: IScanSettings,
    patch: PartialScanSettings
): IScanSettings => {
    return {
        ...current,
        ...patch,
    };
};

export const isEmptyObject = (value: unknown): boolean => {
    if (!value || typeof value !== "object") {
        return true;
    }

    return Object.keys(value as Record<string, unknown>).length === 0;
};
